<template>
  <div
    class="with-close-icon-wrapper"
    :class="{
      'with-shadow': showShadowOnIcon,
      ['icon-' + iconAlignment]: true
    }"
    :style="wrapperStyle"
  >
    <div class="item" :class="itemWrapperClass">
      <slot></slot>
      <i
        tabindex="0"
        class="dismiss"
        :class="{
          'close-icon': closeIconColor === 'grey',
          'close-white-icon': closeIconColor === 'white',
          [iconAlignment]: true
        }"
        :title="dismissTitle"
        @click.stop="$emit('close', $event)"
      ></i>
    </div>
  </div>
</template>

<script>
/**
 * This adds a close icon at the end of the slot provided.
 * Close icon gets visible on hover of the slot (container)
 *
 * @emits
 * - close: gets emitted when close icon is clicked
 */
export default {
  name: 'WithCloseIcon',
  props: {
    wrapperStyle: { default: () => ({}) },
    dismissTitle: String,
    /**
     * this indicates the color of close icon
     * possible values - white, grey
     */
    closeIconColor: {
      default: 'grey',
      type: String
    },
    iconAlignment: {
      default: 'right' // possible values - top | right
    },
    /**
     * css class to add on the wrapper of <slot />
     */
    itemWrapperClass: {
      default: ''
    },
    /**
     * this controls whether dismiss icon should have shadow
     */
    showShadowOnIcon: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.dismiss {
  cursor: pointer;
  background-color: $documentColor;
  border-radius: 50%;
  padding: 8px;
  background-position: center;
  position: absolute;
  opacity: 0;
  transition: opacity ease-out 200ms;
  right: 0;

  &.top {
    transform: translate3d(80%, -35%, 0);
    top: 0;
  }

  &.right {
    top: 50%;
    transform: translateY(-50%);
  }
}

.close-white-icon {
  background-color: $secondary;
}

.item {
  &:hover > .dismiss {
    opacity: 1;
  }
}

.item {
  position: relative;
}

.icon-right {
  .item {
    padding-right: 22px;
  }

  .dismiss {
    right: 4px;
  }
}

.with-shadow {
  .dismiss {
    box-shadow: $iconShadow;
  }
}
</style>
